var _style, _defs, _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:#DB093D;}\n\t.st2{fill:#0069C1;}\n\t.st3{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Objeto_inteligente_vectorial"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Objeto_inteligente_vectorial-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_43"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 8,
    y: 1.9,
    width: 32.1,
    height: 46.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_47",
    className: "st1",
    d: "M24,48c-1,0-1.8-0.6-2.1-1.5l-1.6-4.9c-1.5-4.6-4.1-8.8-7.6-12.2 C6.5,23.2,6.4,13,12.6,6.7S29,0.3,35.3,6.5s6.4,16.4,0.2,22.7c-0.1,0.1-0.2,0.2-0.3,0.3c-3.5,3.4-6,7.6-7.5,12.2l-1.5,4.8 C25.8,47.4,25,48,24,48"
  }))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Color_Overlay",
    className: "st2",
    d: "M22,46.5l-1.6-4.9c-1.5-4.6-4.1-8.8-7.6-12.2C9.7,26.4,8,22.3,8,18v-0.2 C8,9,15.2,1.9,24.1,1.9c4.2,0,8.3,1.7,11.3,4.7c6.3,6.3,6.3,16.4,0,22.7c-0.1,0.1-0.2,0.2-0.2,0.2c-3.5,3.4-6,7.6-7.5,12.2 l-1.5,4.8c-0.4,1.1-1.6,1.8-2.7,1.4C22.7,47.7,22.2,47.2,22,46.5L22,46.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "t7AOQr.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.1,20.9c0,0.1,0,0.3,0,0.4c0,1.2,0,2.5,0,3.7c0,0.6-0.2,0.8-0.9,0.8c-1.5,0-3,0-4.5,0 c-0.6,0-0.8-0.2-0.8-0.8c0-1.2,0-2.5,0-3.7c0-0.1,0-0.2,0-0.4c-0.1,0-0.2,0-0.3,0c-1.2,0-2.5,0-3.7,0c-0.7,0-0.9-0.2-0.9-0.9 c0-1.5,0-3,0-4.5c0-0.6,0.2-0.8,0.8-0.8c1.3,0,2.5,0,3.8,0c0.1,0,0.2,0,0.4,0c0-0.1,0-0.2,0-0.4c0-1.2,0-2.5,0-3.7 c0-0.7,0.2-0.9,0.8-0.9c1.5,0,3,0,4.5,0c0.6,0,0.8,0.2,0.8,0.8c0,1.2,0,2.5,0,3.7c0,0.1,0,0.2,0,0.4c0.1,0,0.2,0,0.3,0 c1.3,0,2.5,0,3.8,0c0.6,0,0.8,0.2,0.8,0.8c0,1.5,0,3,0,4.5c0,0.6-0.2,0.8-0.9,0.8c-1.2,0-2.5,0-3.7,0 C27.4,20.9,27.3,20.9,27.1,20.9z M22.2,11c0,0.1,0,0.2,0,0.3c0,1.3,0,2.5,0,3.8c0,0.6-0.2,0.8-0.8,0.8c-1.3,0-2.5,0-3.8,0 c-0.1,0-0.2,0-0.3,0c0,1.3,0,2.5,0,3.7c0.1,0,0.2,0,0.3,0c1.3,0,2.5,0,3.8,0c0.6,0,0.8,0.2,0.8,0.8c0,1.3,0,2.5,0,3.8 c0,0.1,0,0.2,0,0.3c1.3,0,2.5,0,3.7,0c0-0.1,0-0.2,0-0.3c0-1.3,0-2.5,0-3.8c0-0.6,0.2-0.8,0.8-0.8c1.3,0,2.6,0,3.8,0 c0.1,0,0.2,0,0.3,0c0-1.3,0-2.5,0-3.7c-0.1,0-0.2,0-0.3,0c-1.3,0-2.5,0-3.8,0c-0.6,0-0.8-0.2-0.8-0.8c0-1.3,0-2.6,0-3.8 c0-0.1,0-0.2,0-0.3C24.7,11,23.4,11,22.2,11z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarker);
export default __webpack_public_path__ + "static/media/icon-marker.0a6604d5ca8751be33812e9eb50b4670.svg";
export { ForwardRef as ReactComponent };